export default __webpack_public_path__ + "static/media/irys_w.7fdd1381.png";